import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';

import { PresenterViewComponent } from './PresenterView.Component';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';

const exports = [
	PresenterViewComponent
];

@NgModule({
	declarations: exports,
	exports,
	imports: [
		BsDropdownModule,
		ButtonsAngularModule,
		CommonModule,
		DirectivesAngularModule,
		FormsModule,
		SelectAngularModule,
		SpinnerAngularModule,
		TranslateModule
	]
})
export class SelfProducedModule {

}
